import { InstructionComponentProps } from "../InstructionComponent"
import OuraSetupInstructionPart1  from "./OuraSetupInstructionPart1"
import OuraSetupInstructionPart2  from "./OuraSetupInstructionPart2"

const OuraSetupInstructions: InstructionComponentProps = {
  name: "Wie richte ich meinen Oura Ring ein?",
  path: "/help/patient/oura",
  description:
    "Um den Oura Ring mit der DOOR Studie Connect App zu verbinden, ist es notwendig, dass Sie den Oura Ring einrichten.",
  both: [
    // Spread the single step from Part 1
    ...OuraSetupInstructionPart1.both || [],

    // Spread the five steps from Part 2
    ...OuraSetupInstructionPart2.both || []
  ]
}

export default OuraSetupInstructions
